import { useStore } from 'zustand';

const useErrorModalStore = select =>
  useStore(window.NikeShop.__INTERNAL_USE__.errorModalStore, select);

export default useErrorModalStore;
